const COMPONENT_NAME = "FeatureHighlightCardV2";
const VIEW_NAME_SKELETON = "skeleton";
const VIEW_NAME_FEATURE = "feature";
const VIEW_NAME_GENERAL = "general";
const VIEW_NAME_IMAGE_WITH_LEGEND = "image-with-legend";
const VIEW_NAME_MAP = {
  feature_variant: VIEW_NAME_FEATURE,
  general_variant: VIEW_NAME_GENERAL,
  image_with_legend: VIEW_NAME_IMAGE_WITH_LEGEND
};
const ORIENTATION_MAP = {
  horizontal: "row",
  vertical: "column"
};
export {
  COMPONENT_NAME,
  ORIENTATION_MAP,
  VIEW_NAME_FEATURE,
  VIEW_NAME_GENERAL,
  VIEW_NAME_IMAGE_WITH_LEGEND,
  VIEW_NAME_MAP,
  VIEW_NAME_SKELETON
};
